import { __decorate } from 'tslib';
import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { NG_DOC_STORE_THEME_KEY } from '@ng-doc/app/constants';
import { NgDocStoreService } from '@ng-doc/app/services/store';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';

/**
 * Service for managing themes.
 */
let NgDocThemeService = /*#__PURE__*/(() => {
  let NgDocThemeService = class NgDocThemeService {
    constructor() {
      this.document = inject(DOCUMENT);
      this.store = inject(NgDocStoreService);
      this.change$ = new Subject();
      this.documentElement = this.document.documentElement;
    }
    /**
     * Returns the current theme.
     */
    get currentTheme() {
      return document.documentElement.getAttribute('data-theme');
    }
    themeChanges() {
      return this.change$.asObservable();
    }
    /**
     * Sets the theme by id.
     * @param id - Theme id. If not provided, the theme will be removed.
     */
    set(id) {
      id ? this.documentElement.setAttribute('data-theme', id) : this.documentElement.removeAttribute('data-theme');
      this.store.set(NG_DOC_STORE_THEME_KEY, id ?? '');
      this.change$.next(id ?? null);
    }
    static {
      this.ɵfac = function NgDocThemeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocThemeService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgDocThemeService,
        factory: NgDocThemeService.ɵfac,
        providedIn: 'root'
      });
    }
  };
  NgDocThemeService = __decorate([UntilDestroy()], NgDocThemeService);
  return NgDocThemeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocThemeService };
